module.exports = __webpack_public_path__ + "static/media/193.652d8cda.jpg";